
<div class="flow-timeseries-container" :empty="empty" :state="state" :transparent="transparent">
	<div v-if="draggable" class="flow-timeseries-draggable">
		<Icon name="i-arrange" size="small" state="dark" :effects="false" type="filled" />
	</div>
	<div class="flow-timeseries-topbar">
		<div class="flow-timeseries-header">
			{{ header }}
		</div>
		<div class="flow-timeseries-legends">
			<div
				v-for="(sr, srindex) in series"
				:key="srindex + '_time_legend'"
				class="flow-timeseries-legend"
				:disabled="
					chart && type === 'chart' ? chart.data.shown(sr.name).length === 0 : showDisabled
				"
				@mouseout="handleLegendOut()"
				@mouseover="handleLegendHover(sr.name)"
				@click="handleLegendClick(sr.name)"
			>
				<span class="flow-legend-circle" :style="'background-color:' + getSeriesColor(sr)" />
				<span class="flow-legend-label text-ellipsis">{{ sr.label ? sr.label : sr.name }}</span>
			</div>
		</div>
	</div>
	<Loader v-if="loading" position="absolute" />
	<div v-show="type === 'chart'" ref="chartdom" class="flow-timeseries-chart" />
	<div
		v-show="type === 'number' && !loading"
		ref="numberdom"
		class="flow-timeseries-number"
		:style="{ fontSize: numberFontSize.bignumber + 'px' }"
	>
		<template v-for="(activeSeries, idx) in series">
			<div
				v-if="activeSeriesIndex === idx"
				:key="activeSeries.name"
				class="flow-timeseries-number-stat"
				:data-series-count="series.length"
				:set="((dev = getDeviation(activeSeries)), (value = getLatestValue(activeSeries)))"
			>
				<div class="flow-timeseries-number-latest" :style="{ color: activeSeries.color }">
					{{ value.y }}
				</div>
				<div
					class="flow-timeseries-number-symbol"
					:style="{ color: activeSeries.color, fontSize: numberFontSize.symbol + 'px' }"
				>
					{{ value.unit }}
				</div>
				<div
					v-if="dev.value !== 0"
					class="flow-timeseries-number-deviation"
					:style="{ fontSize: numberFontSize.deviation + 'px' }"
				>
					<span class="flow-ts-n-d-symbol">
						<Icon
							v-if="dev.type !== 'neutral'"
							name="filled-arrow"
							:rotate="dev.type === 'negative' ? 0 : 180"
							size="small"
							type="filled"
							:effects="false"
							:state="getDeviationIconState(dev.type)"
						/>
					</span>
					{{ dev.value }}
				</div>
			</div>
			<div
				v-if="activeSeriesIndex === idx"
				:key="activeSeries.name + '_label'"
				:data-series-count="series.length"
				class="flow-timeseries-label"
			>
				{{ activeSeries.name }}
			</div>
		</template>
	</div>
	<AlarmCircle
		v-if="state === 'error' || state === 'warning'"
		class="flow-timeseries-alarm-circle"
		:type="state"
	>
		<Icon name="bell-ring" state="light" :effects="false" @click="handleAlarmClick($event)" />
	</AlarmCircle>
</div>
